import EstornarItemAdesaoInput from '@/core/apiclient/item-adesao/estorno/models/EstornarItemAdesaoInput'

export default {
	form: new EstornarItemAdesaoInput(),
}
